enum ActionType {
    REQUEST_SFM_SCORES = '[CORE/SFM] GET SFM SCORES',
    RECEIVE_SFM_SCORES = '[CORE/SFM] SET SFM SCORES',
}

export default ActionType
